export default __webpack_public_path__ + "static/media/ir.ab0fd32f.svg";